/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */

import { CustomAttributeData } from '../../customAttributes/customAttributes';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';

export const SLTXDefaultFolderName = 'Root';

export class SLTXFormatRootFileGroupOption {
  id = 0;
  name = '';
  objectRef = '';
  thumbnailRef = '';
  tagTranslation: CatalogTagsTranslation | undefined;
  tagTranslationSection: CatalogTagsTranslation | undefined;
}

export class SLTXFormatRootFileGroupOptionFolder {
  name = '';
  thumbnailRef: string | undefined;
  options: SLTXFormatRootFileGroupOption[] = [];
  tagTranslation: CatalogTagsTranslation | undefined;
}

export class SLTXFormatRootFileGroup {
  id = 0;
  name = '';
  optionsFolders: SLTXFormatRootFileGroupOptionFolder[] = [];
  tagTranslation: CatalogTagsTranslation | undefined;
}

export class SLTXFormatRootFileVariantComposition {
  groupId = 0;
  optionId = 0;
}

export class SLTXFormatRootFileVariant {
  backgroundColor = '';
  imageRef = '';
  name = '';
  thumbnailRef = '';
  variantComposition: SLTXFormatRootFileVariantComposition[] = [];
}

export class SLTXFormatRootFile {
  version: number = 0;
  name = '';
  groups: SLTXFormatRootFileGroup[] | undefined;
  objects = '';
  thumbnail = '';
  variants: SLTXFormatRootFileVariant[] | undefined;
  customAttributes: CustomAttributeData[] | undefined;
}
